var n=function(n){"undefined"!=typeof window&&window.open(n,"_blank")};export{n as redirectExternalUrl};
//# sourceMappingURL=index.js.map
